export default {
  root: {
    paddingTop: '6px',
    paddingBottom: '6px',
  }
}